import { isOnSchemaTargetPath as e } from "./is-on-schema-target-path.js";
import { nextTick as t, onBeforeUnmount as n, onMounted as r, shallowReactive as i, shallowRef as a, watch as o } from "vue";
//#region src/schema/helpers/schema-expansion.ts
var s = (e, t) => t === "" || e === t || e.startsWith(`${t}.`), c = (e) => e?.join(".") ?? "", l = 300, u = (n = a("")) => {
	let r = i(/* @__PURE__ */ new Map()), o = i(/* @__PURE__ */ new Map()), c = a("default"), u = (e) => {
		if (o.size === 0) return;
		let t = e;
		for (;;) {
			let e = o.get(t);
			if (e !== void 0) return e;
			let n = t.lastIndexOf(".");
			if (n === -1) return o.get("");
			t = t.slice(0, n);
		}
	}, d = (e) => {
		for (let t of [...r.keys()]) s(t, e) && r.delete(t);
	}, f = !1, p = (e) => {
		f = !0, e(), t(() => {
			f = !1;
		});
	}, m = (e, t) => {
		if (d(e), e === "") {
			o.clear(), c.value = t ? "expanded" : "collapsed";
			return;
		}
		for (let t of [...o.keys()]) s(t, e) && o.delete(t);
		o.set(e, t);
	}, h = (t, i = {}) => {
		let a = r.get(t);
		if (a !== void 0) return a;
		if (!i.cyclic) {
			let e = u(t);
			if (e !== void 0) return e;
			if (c.value === "expanded") return !0;
			if (c.value === "collapsed") return !1;
		}
		return e(i.anchorPath ?? t, n.value) ? !0 : i.defaultOpen ?? !1;
	}, g = (e, t) => {
		r.set(e, t);
	};
	return {
		isExpanded: h,
		setExpanded: g,
		toggle: (e, t) => g(e, !h(e, t)),
		expandAll: (e = "") => m(e, !0),
		collapseAll: (e = "") => p(() => m(e, !1)),
		commitPath: (e) => {
			if (!e) return;
			let t = e.split(".");
			for (let e = 1; e <= t.length; e++) {
				let n = t.slice(0, e).join(".");
				r.set(n, !0);
				let i = n.lastIndexOf(".");
				i !== -1 && r.set(`${n.slice(0, i)}.~${n.slice(i + 1)}`, !0);
			}
		},
		baseline: c,
		pauseRetentionFor: p,
		untilFound: (() => {
			let e = 0;
			return {
				acquire: () => f || e >= l ? !1 : (e += 1, !0),
				release: () => {
					e = Math.max(0, e - 1);
				}
			};
		})()
	};
}, d = Symbol("schema-tree-root"), f = (e = a("")) => {
	let t = u(e);
	return r(() => {
		o(e, (e) => {
			e && t.commitPath(e);
		}, { immediate: !0 });
		let r = null, i = () => {
			r = t.baseline.value, t.baseline.value = "expanded";
		}, a = () => {
			if (r !== null) {
				let e = r;
				t.pauseRetentionFor(() => {
					t.baseline.value = e;
				}), r = null;
			}
		};
		window.addEventListener("beforeprint", i), window.addEventListener("afterprint", a), n(() => {
			window.removeEventListener("beforeprint", i), window.removeEventListener("afterprint", a);
		});
	}), t;
};
//#endregion
export { d as SCHEMA_TREE_ROOT_SYMBOL, u as createSchemaExpansionStore, c as toNodeKey, f as useSchemaExpansion };

//# sourceMappingURL=schema-expansion.js.map